import { BillOfMaterialListPage } from '@/features/bill-of-material/pages/BillOfMaterialListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/bill-of-material/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["bill_of_material.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BillOfMaterialListPage,
})
